import { ItemV7ViewModel } from './itemV7.view-model';

export class ItemHomeViewModel {
    public id: string;
    public section: string;
    public items: ItemV7ViewModel[] = [];
}
